var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesPageBannerW360Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.699707,
    width: 360,
    height: 300,
    fill: "url(#paint0_linear_10771_16461)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.74 254.451C190.727 254.451 190.727 246.7 185.74 246.7C180.753 246.7 180.753 254.451 185.74 254.451Z",
    fill: "#A3EA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7401 189.451C61.7269 189.451 61.7269 181.7 56.7401 181.7C51.7533 181.7 51.7533 189.451 56.7401 189.451Z",
    fill: "#A3EA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87973 196.105C4.38605 196.105 4.38605 192.229 1.87973 192.229C-0.626578 192.229 -0.626578 196.105 1.87973 196.105Z",
    fill: "#A3EA2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3543 300.8C76.8607 300.8 76.8607 296.924 74.3543 296.924C71.848 296.924 71.848 300.8 74.3543 300.8Z",
    fill: "#A3EA2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.303 264.734C361.289 264.734 361.289 256.983 356.303 256.983C351.316 256.983 351.316 264.734 356.303 264.734Z",
    fill: "#A3EA2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.88 203.575C256.386 203.575 256.386 199.7 253.88 199.7C251.373 199.7 251.373 203.575 253.88 203.575Z",
    fill: "#A3EA2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.571 300.208C310.077 300.208 310.077 296.333 307.571 296.333C305.065 296.333 305.065 300.208 307.571 300.208Z",
    fill: "#A3EA2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_16461",
    x1: 152.618,
    y1: -144.5,
    x2: 505.853,
    y2: 214.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#182337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#151C2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesPageBannerW360Px);
export default __webpack_public_path__ + "static/media/resources-page-banner-w360px.00378b07a32a3ca6db1fc596ac9ac740.svg";
export { ForwardRef as ReactComponent };